const $ = jQuery

/**
 * Pause media when a Bootstrap modal or collapse is hidden
 * @param {Event} event - The Boostrap hide event (either modal or collapse)
 */
export const pauseMediaOnHide = (event) => {
    $(event.currentTarget)
        .find('audio, video, iframe')
        .each(function () {
            if (this.tagName == 'IFRAME') {
                this.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    '*'
                )
            } else {
                this.pause()
            }
        })
}
